import {
    GETBUSINESSNATURETABLELIST_SUCCESS,
    GETBUSINESSNATURETABLELIST_FAILED,
    RESET_GETBUSINESSNATURETABLELIST,
    LOADING_GETBUSINESSNATURETABLELIST,
    NETWORK_ERROR_GETBUSINESSNATURETABLELIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetBusinessNatureTableList = () => {
    return { type: RESET_GETBUSINESSNATURETABLELIST };
};

const getBusinessNatureTableList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETBUSINESSNATURETABLELIST });
    await adminServices
        .post("getBusinessNatureListCopy", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getBusinessNatureTableListsuccess(res.data));
                    break;
                default:
                    dispatch(getBusinessNatureTableListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETBUSINESSNATURETABLELIST,
                payload: err,
            });
        });
};
function getBusinessNatureTableListsuccess(data) {
    return {
        type: GETBUSINESSNATURETABLELIST_SUCCESS,
        payload: data,
    };
}
function getBusinessNatureTableListFailed(data) {
    return {
        type: GETBUSINESSNATURETABLELIST_FAILED,
        payload: data,
    };
}

export { resetGetBusinessNatureTableList, getBusinessNatureTableList };
